import React, { useEffect, useState } from "react";
import { adminApi, isAbortError } from "../../api/adminApi";
import "./analytics-provider-select.scss";

export function useAnalyticsProvider(site) {
  const [options, setOptions] = useState([]);
  const [selection, setSelection] = useState({ key: "local", model: null });
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    adminApi.analyticsAiProviders(site, controller.signal).then(result => {
      const available = Array.isArray(result) ? result.flatMap(provider => (provider.models || []).map(model => ({ key: provider.key, model, name: provider.name }))) : [];
      setOptions(available);
      setSelection(available.find(option => option.key === "local") || { key: "local", model: null, name: "Local AI" });
      setError("");
    }).catch(exception => { if (!isAbortError(exception)) setError(exception.message); });
    return () => controller.abort();
  }, [site]);

  const choose = value => {
    const selected = options.find(option => JSON.stringify([option.key, option.model]) === value);
    if (!selected) return;
    setSelection(selected);
  };
  return { options, selection, choose, error };
}

export default function AnalyticsProviderSelect({ options, selection, choose, error }) {
  return <div className="analytics-provider-select"><label>AI provider<select value={JSON.stringify([selection.key, selection.model])} onChange={event => choose(event.target.value)} disabled={!options.length}>{!selection.model && <option value={JSON.stringify(["local", null])} disabled>{options.length ? "Local AI unavailable — select a provider" : "No AI provider available"}</option>}{options.map(option => <option key={`${option.key}:${option.model}`} value={JSON.stringify([option.key, option.model])}>{option.name} · {option.model}</option>)}</select></label>{selection.key !== "local" && <small>Analysis data will be sent to {selection.name}.</small>}{error && <small role="alert">{error}</small>}</div>;
}
